var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4Retail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Grupo_2",
    "data-name": "Grupo 2",
    width: 192.129,
    height: 53.814,
    viewBox: "0 0 192.129 53.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6",
    "data-name": "Rect\\xE1ngulo 6",
    width: 192.129,
    height: 53.814,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M425.082,85.278c-10.864,0-16.258,8-16.258,18.527,0,8.975,4.694,17.675,15.889,17.675,10.162,0,13.935-6.359,15.249-10.7h-7.616c-1.031,2.342-2.543,4.636-7.418,4.636-5.444,0-8.42-4.666-8.448-10.535H440.4a24.589,24.589,0,0,0,.108-2.889c0-7.916-3.854-16.711-15.422-16.711m-.057,5.637c5.3,0,7.66,3.885,7.825,8.708H416.72c.578-5.09,2.932-8.708,8.305-8.708",
    transform: "translate(-324.988 -67.79)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M575.091,38.826H567.5V49.163h-5.752v5.872H567.5V75.2c0,5.876,2.337,9.016,8.357,9.016a18.825,18.825,0,0,0,5.765-.648v-5.4a14.186,14.186,0,0,1-2.68.21c-3.037,0-3.856-1.421-3.856-4.464V55.035h7.328V49.163h-7.328Z",
    transform: "translate(-446.556 -30.864)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M698.947,97.465c0-8.022-4.878-11.539-13.756-11.579-10.279-.039-13.623,5.238-14.111,10.6h7.272c.553-2.615,1.5-4.987,6.574-4.987,5.648,0,6.592,3.162,6.592,5.956v3.289h-5.534c-10.309,0-16.54,2.874-16.54,10.661,0,5.3,3.528,10.686,11.834,10.686,6.513,0,9.12-2.695,10.358-4.845a16.7,16.7,0,0,0,.535,4.033h7.254a62.817,62.817,0,0,1-.477-8.14Zm-7.4,8.456c0,5.543-.97,10.559-8.4,10.559-3.947,0-6.031-2.4-6.031-5.525,0-4.212,3.051-5.354,9.519-5.354h4.911Z",
    transform: "translate(-532.163 -68.274)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1",
    "data-name": "Rect\\xE1ngulo 1",
    width: 7.587,
    height: 34.58,
    transform: "translate(171.655 18.428)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2",
    "data-name": "Rect\\xE1ngulo 2",
    width: 7.587,
    height: 6.698,
    transform: "translate(171.655 5.312)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3",
    "data-name": "Rect\\xE1ngulo 3",
    width: 7.587,
    height: 47.695,
    transform: "translate(184.542 5.312)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M327.249,183.854l-12.181-19.315H303.122L315.3,183.854Z",
    transform: "translate(-240.962 -130.798)",
    fill: "#ff0900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M0,52.391l15.77-26.5H27.716l-15.77,26.5Z",
    transform: "translate(0 -20.581)",
    fill: "#ff0900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M15.367,26.562,31.138.061H43.084l-15.77,26.5Z",
    transform: "translate(-12.216 -0.049)",
    fill: "#ff0900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M247.022,37.109l-10.593,0,6.8-10.593,3.793-.01a7.948,7.948,0,0,0,0-15.9H229.058V0h17.964a18.555,18.555,0,0,1,0,37.109",
    transform: "translate(-182.086)",
    fill: "#ff0900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M25.1,165.711l6.8-10.593H63.788v10.593Z",
    transform: "translate(-19.953 -123.309)",
    fill: "#ff0900"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4",
    "data-name": "Rect\\xE1ngulo 4",
    width: 10.599,
    height: 52.995,
    transform: "translate(27.845 0.013)",
    fill: "#ff0900"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_5",
    "data-name": "Rect\\xE1ngulo 5",
    width: 10.599,
    height: 52.995,
    transform: "translate(43.744 0.013)",
    fill: "#ff0900"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Retail);
export default __webpack_public_path__ + "static/media/4Retail.8f74a70c6910a8321c561970bac3b065.svg";
export { ForwardRef as ReactComponent };